import { reactive } from '@vue/composition-api'
import { Epworth } from '@/types'
import repositories from '@/repositories'

export const epworthProps: {
  list: Epworth[];
  loading: boolean;
} = reactive({
  list: [],
  loading: false
})

export const loadEpworthProps = async () => {
  try {
    epworthProps.loading = true
    const res = await repositories.epworth.getEpworthProps()

    epworthProps.list = res.data
      .map((epworth: any) => ({ ...epworth, selected: -1 }))
  } catch (err) {} finally {
    epworthProps.loading = false
  }
}
